import React, { Component } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

class AppLayout extends Component {
  render() {
    return (
      <div className="app-layout">
        <Sidebar />

        <div className="app-layout-main">
          <Header />

          <main className="app-layout-content">
            {this.props.children}
          </main>
        </div>
      </div>
    );
  }
}

export default AppLayout;